import { render, staticRenderFns } from "./BASnackbar.vue?vue&type=template&id=1f225584&scoped=true&"
import script from "./BASnackbar.vue?vue&type=script&lang=ts&"
export * from "./BASnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./BASnackbar.vue?vue&type=style&index=0&id=1f225584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f225584",
  null
  
)

export default component.exports